<template>
  <div class="mansionInfo">
    <div class="title">
      <div class="img-box">
        <img src="@/assets/img/hospital2.png" alt="">
      </div>
      <span>{{ infoCon.constructName }}
        <span class="status" :class="status==1?'cor1':status==2?'cor2':'cor3'">{{ status==1?'已开通':status==2?'已过期':'未开通' }}</span>
      </span>
    </div>
    <div class="line" />
    <div class="desc">
      <div class="desc-item">{{ infoCon.introduction }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MansionInfo",
  props: ["infoCon", 'status']
}
</script>
 <style lang="scss" scoped>
 :root{
     --scale:1,
 }
 $scale:var(--scale, 1);
  .mansionInfo{
     width: calc(#{$scale} * 260px);
     height: calc(#{$scale} * 60px);
     border-radius: calc(#{$scale} * 8px);
     border:  calc(#{$scale} * 2px) solid #DD594A;
     box-sizing: border-box;
     position:absolute;
     top: 0px;
     left: 50%;
     transform:translate(-50%,0);
     background: rgba(0, 28, 28, 0.50);
     z-index: 9;
     .cor1{
        color: #71AC34;
     }
     .cor2{
        color: #F5B53D;
     }
     .cor3{
        color: #BFBFBF;
     }
     .status{
        position: absolute;
        right: 0;
        top: 0;
        font-size:calc(#{$scale} * 14px);
        width: calc(#{$scale} * 80px);
        height: calc(#{$scale} * 24px);
        background: rgba(0,0,0,0.3);
        border-radius: 0px calc(#{$scale} * 7px) 0px calc(#{$scale} * 7px);
        text-align: center;
        line-height:  calc(#{$scale} * 24px);
     }
     &:hover{
         height: auto;
         z-index: 10;
         .title{
             border-radius:calc(#{$scale} * 8px) calc(#{$scale} * 8px) 0 calc(#{$scale} * 8px);
             box-sizing: content-box;
             border-bottom: calc(#{$scale} * 2px) solid #DD594A;
         }
         .line{
             display: none;
         }
         .desc{
             // border-top: 2px solid #DD594A;
             display: block;
         }
     }
     .title{
         height: calc(#{$scale} * 56px);
         display: flex;
         font-size: calc(#{$scale} * 20px);
         font-family: PingFangSC, PingFang SC;
         font-weight: 500;
         color: #FFFFFF;
         border-radius: calc(#{$scale} * 8px);
         align-items: center;
         .img-box{
             width: calc(#{$scale} * 60px);
             height: calc(#{$scale} * 60px);
             background: #DD594A;
             display: flex;
             justify-content: center;
             align-items: center;
             border-radius:calc(#{$scale} * 8px);;
             margin-left: calc(#{$scale} * -1px);
             img{
                 width: calc(#{$scale} * 42px);;
                 height: calc(#{$scale} * 42px);;
                 display: block;
             }
         }
         span{
             text-align: center;
             flex: 1;
         }
     }
     .line{
         width: calc(#{$scale} * 1px);;
         height: calc(#{$scale} * 31px);;
         background: #DD594A;
         position: absolute;
         left: 50%;
         top: calc(#{$scale} * 60px);;
     }
     .desc{
         color: #FFFFFF;
         display: none;
         border-radius: 0 0 calc(#{$scale} * 8px) calc(#{$scale} * 8px);
         padding: calc(#{$scale} * 8px) 0;
         &-item{
             // font-size: 16px;
             padding:calc(#{$scale} * 4px) calc(#{$scale} * 15px);
             width:100%;
             font-size: calc(#{$scale} * 18px);;
             font-family: PingFangSC, PingFang SC;
             font-weight: 400;
             color: #FFFFFF;
             line-height: calc(#{$scale} * 26px);;
             opacity: 0.8;
         }
     }
 }
 </style>
